import React, { useState, useEffect } from "react";
import UploadedCopy from "./UploadedCopy";
import ConfirmSection from "./ConfirmSection";
import Guarantor from "./Guarantor";
import WifeIndentification from "./WifeIndentification";
import RiderIdenfification from "./RiderIdenfification";
import BasicInformation from "./BasicInformation";
import YourIncome from "./ YourIncome";
import ParentInformation from "./ParentInformation";
import { Button, message, Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAsyncProvinces,
  getAgent,
  setRiderPhoneNumber,
} from "../../redux/transactions/UntappedSlice";
import { motion, AnimatePresence } from "framer-motion";
import SuccessMessage from "./SuccessMessage";
import CustomStep from "./CustomStep";

const TOTAL_STEPS = 9;

const STEP_TITLES = {
  1: "UMWIRONDORO W'UMUSHOFERI",
  2: "AMAKURU Y'IBANZE",
  3: "AMAKURU AJYANYE NUKO WINJIZA",
  4: "UMWIRONDORO W'UWO MWASHAKANYE",
  5: "AMAKURU Y'ABABYEYI",
  6: "IMYIRONDORO Y'UMWISHINGIZI",
  7: "AMAKURU Y'UMUGEREKA",
  8: "INJIZA COPY Z'IBYANGOBWA BYASABWE",
  9: "KWEMEZA AMAKURU YOSE Y'UMUSHOFERI",
};

const CarMultiStepForm = () => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const loggedInAgent = useSelector(getAgent);

  const motariStaggingUrl =
    "https://applicationbackend.jalikoi.rw/api/v2/carleasing";
  const motarFileUrl = "https://applicationbackend.jalikoi.rw/api/v2";

  const stepVariants = {
    initial: { opacity: 0, x: 50 },
    animate: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    exit: { opacity: 0, x: -50, transition: { duration: 0.3, ease: "easeIn" } },
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [darkMode, setDarkMode] = useState(true);
  const [isConfirmedSent, setIsConfirmedSent] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentApplicant, setCurrentApplicant] = useState("");

  // File states
  const [uploadedIDFile, setuploadedIDFile] = useState("");
  const [uploadedFile, setuploadedFile] = useState("");
  const [file_YELLOW_CARD, setfile_YELLOW_CARD] = useState("");
  const [file_CONTRACT, setfile_CONTRACT] = useState("");
  const [file_BUSINESS_CERTIFICATE, setfile_BUSINESS_CERTIFICATE] =
    useState("");

  // Form data states with localStorage initialization
  const [riderBasicInformation, setRiderBasicInformation] = useState(
    () => JSON.parse(localStorage.getItem("riderBasicInformation")) || {},
  );
  const [riderIdentification, setRiderIdentification] = useState(
    () => JSON.parse(localStorage.getItem("riderIdentification")) || {},
  );
  const [incomeData, setIncomeData] = useState(
    () => JSON.parse(localStorage.getItem("incomeData")) || {},
  );
  const [wifeIdentifications, setWifeIdentifications] = useState(
    () => JSON.parse(localStorage.getItem("wifeIdentifications")) || {},
  );
  const [parentInformation, setParentInformation] = useState(
    () => JSON.parse(localStorage.getItem("parentInformation")) || {},
  );
  const [guarantor, setGuarantor] = useState(
    () => JSON.parse(localStorage.getItem("guarantor")) || {},
  );
  const [customStep, setCustomStep] = useState(
    () => JSON.parse(localStorage.getItem("customStep")) || {},
  );
  const [uploadedCopies, setUploadedCopies] = useState(() => ({}));

  // ── Change handlers ────────────────────────────────────────────────────────
  const handleBasicInformationChange = (formData) =>
    setRiderBasicInformation(formData);

  const handleRiderIdentificationChange = (formData) => {
    if (formData.phone) dispatch(setRiderPhoneNumber(formData.phone));
    setRiderIdentification(formData);
  };

  const HandleIncomeData = (formData) => {
    console.log("Received income data:", formData);
    setIncomeData(formData);
  };

  const handleWifeIdentificationChange = (formData) =>
    setWifeIdentifications(formData);
  const handleParentInformationChange = (formData) =>
    setParentInformation(formData);

  const handleGuarantorChange = ({
    guarantorsData,
    uploadedFile,
    uploadedIDFile,
    file_YELLOW_CARD,
    file_CONTRACT,
    file_BUSINESS_CERTIFICATE,
  }) => {
    if (uploadedFile) setuploadedFile(uploadedFile);
    if (uploadedIDFile) setuploadedIDFile(uploadedIDFile);
    if (file_YELLOW_CARD) setfile_YELLOW_CARD(file_YELLOW_CARD);
    if (file_CONTRACT) setfile_CONTRACT(file_CONTRACT);
    if (file_BUSINESS_CERTIFICATE)
      setfile_BUSINESS_CERTIFICATE(file_BUSINESS_CERTIFICATE);
    setGuarantor(guarantorsData);
  };

  const handleCustomStepChange = (formData) => setCustomStep(formData);
  const handleUploadedCopiesChange = (formData) => setUploadedCopies(formData);
  const handleConfirmChange = async (checked) => setIsConfirmed(checked);

  const resetApplicationForm = () => {
    setIsSubmitting(false);
    setCurrentStep(1);
    setIsConfirmedSent(false);
    setUploadProgress(0);
    localStorage.clear();
    window.location.replace("/jali-application-form");
  };

  // ── Create custom car before step 3 submission ────────────────────────────
  const createCustomCar = async () => {
    try {
      const response = await fetch(`${motariStaggingUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: incomeData.custom_car_name,
          brand: incomeData.custom_car_brand,
          year: parseInt(incomeData.car_year),
          type: `${incomeData.custom_car_name}_${incomeData.custom_car_brand}`,
          transmission: "FUEL",
          down_payment: 0,
          extra: "some optional note",
        }),
      });

      const data = await response.json();
      console.log("Create custom car response:", data);

      if (!response.ok) {
        throw new Error(
          data?.message || "Gukora imodoka ntibyagenze. Ongera ugerageze.",
        );
      }

      return data?.data?.id ?? null; // ✅ fixed
    } catch (error) {
      throw new Error(error.message || "Habayeho ikosa mu gukora imodoka.");
    }
  };

  // ── File upload (step 8) ───────────────────────────────────────────────────
  const createFormData = async () => {
    setIsSubmitting(true);
    setUploadProgress(0);

    console.log("uploadedIDFile", uploadedIDFile);

    const formData = new FormData();
    const fileAttributes = {
      file_PHOTO: uploadedCopies.profileImage?.originFileObj,
      file_ID: uploadedCopies.nationalIdCopy?.originFileObj,
      file_LETTER: uploadedCopies.loanApplicationLetter?.originFileObj,
      file_DRIVING_LICENCY: uploadedCopies.drivingLicenseCopy?.originFileObj,
      file_MARITAL_STATUS: uploadedCopies.maritalStatusProof?.originFileObj,
      file_VILLAGE: uploadedCopies.residenceProof?.originFileObj,
      file_INSURER_ID: uploadedIDFile,
      file_MOTARI_INSURANCE: uploadedCopies.incomeOrBankStatement?.originFileObj || null,
    };

    Object.entries(fileAttributes).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    try {
      const uploadResponse = await axios.post(
        `${motarFileUrl}/carleasing/upload/${currentApplicant}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setUploadProgress(percentCompleted);
          },
        },
      );

      setUploadProgress(100);
      api.success({
        message: "Igikorwa Cyagenze Neza",
        description: "Igikorwa cyagenze neza! Komeza ku cyiciro gikurikiraho.",
        placement: "topRight",
        duration: 5,
      });

      setTimeout(() => {
        nextStep();
        setUploadProgress(0);
        setIsSubmitting(false);
      }, 500);
    } catch (error) {
      setIsSubmitting(false);
      setUploadProgress(0);
      message.error(
        error.response?.data?.message ||
          "Amakuru watanze si yo. Nyamuneka wongere ugenzure.",
      );
    }
  };

  // ── Step payloads ──────────────────────────────────────────────────────────
  const getStepPayload = () => {
    switch (currentStep) {
      case 1:
        return {
          step: 1,
          car_car_applicant_id: currentApplicant || "",
          first_name: riderIdentification.firstName ?? "",
          middle_name: riderIdentification.middleName ?? "",
          last_name: riderIdentification.lastName ?? "",
          dob: riderIdentification.birthDate ?? "",
          phone: riderIdentification.phone ?? "",
          nid: riderIdentification.idNumber ?? "",
          gender: riderIdentification.gender ?? "",
          branch_id: riderIdentification.branch ?? "",
          email: riderIdentification.email ?? "",
          place_of_birth: riderIdentification.village
            ? parseInt(riderIdentification.village, 10)
            : "",
        };

      case 2:
        return {
          step: 2,
          car_applicant_id: currentApplicant,
          status: riderBasicInformation.maritalStatus ?? "",
          residence: {
            village_id: riderBasicInformation.village
              ? parseInt(riderBasicInformation.village, 10)
              : "",
          },
          driving_licency: riderBasicInformation.licenseNumber ?? "",
          driving_licency_issued_date: riderBasicInformation.issuedDate ?? "",
          home_ownership: riderBasicInformation.houseOwnership ?? "",
          monthly_rent: riderBasicInformation.rent_amount ?? "",
          rent_duration: `${riderBasicInformation.duration?.value ?? ""} ${riderBasicInformation.duration?.type ?? ""}`,
        };

      case 3:
        return {
          step: 3,
          car_applicant_id: currentApplicant,
          daily_income: parseInt(incomeData.daily_income ?? "0", 0),
          source_of_income: incomeData.source_of_income ?? "",
          debts: incomeData.hasDebt ?? "",
          car_id: incomeData.car_id ?? "",
          car_year: parseInt(incomeData.car_year ?? "0", 0),
          loan_amount: parseInt(incomeData.loan_amount ?? "0", 0),
          deposit_accepted: incomeData.deposit_accepted ?? "",
          repayment_period: parseInt(incomeData.repayment_period ?? "0", 0),
          loan_payment_process: incomeData.loan_payment_process ?? "",
        };

      case 4:
        return {
          step: 4,
          car_applicant_id: currentApplicant,
          first_name: wifeIdentifications?.firstName || "",
          last_name: wifeIdentifications?.lastName || "",
          phone: wifeIdentifications?.phoneNumber || "",
          nid: wifeIdentifications?.idNumber || "",
          occupation: wifeIdentifications?.occupation || "",
        };

      case 5:
        return {
          step: 5,
          car_applicant_id: currentApplicant,
          name: parentInformation?.parentName || "",
          phone: parentInformation?.parentPhone || "",
          national_id: parentInformation?.parentNationalId || "",
        };

      case 6: {
        const { insurer_one } = guarantor || {};
        return {
          step: 6,
          car_applicant_id: currentApplicant,
          identity: insurer_one?.nationalId || "",
          first_name: insurer_one?.firstName || "",
          last_name: insurer_one?.lastName || "",
          occupation: insurer_one?.occupation || "",
          phone: insurer_one?.phoneNumber || "",
          gender: "Female",
          residence: {
            village_id: insurer_one?.village
              ? parseInt(insurer_one.village, 10)
              : null,
          },
        };
      }

      case 7:
        return {
          step: 7,
          car_applicant_id: currentApplicant,
          moto_id: parseInt(incomeData?.preferredMotoType?.id ?? "0", 10),
          extra_values: customStep || "",
        };

      case 8:
        return {
          step: 8,
          fileData: uploadedCopies,
          car_applicant_id: currentApplicant,
        };

      // step 9 is now Confirm (was step 10)
      case 9:
        return {
          step: 8,
          car_applicant_id: currentApplicant,
          terms_condition: isConfirmed,
          agent_id: loggedInAgent?.id || "",
        };

      default:
        return {};
    }
  };

  // ── Submit ─────────────────────────────────────────────────────────────────
  const submitStepData = async () => {
    if (isSubmitting) return;

    // File upload step
    if (currentStep === 8) {
      await createFormData();
      return;
    }

    // ── Step 3: create custom car first if user typed one ──────────────────
    if (
      currentStep === 3 &&
      incomeData.custom_car_name &&
      incomeData.custom_car_brand
    ) {
      setIsSubmitting(true);
      try {
        const newCarId = await createCustomCar();
        if (!newCarId) throw new Error("Nta car ID yahawe. Ongera ugerageze.");

        // Patch incomeData with the newly created car_id so getStepPayload picks it up
        setIncomeData((prev) => ({ ...prev, car_id: newCarId }));

        // Build payload manually here since state update is async
        const payload = {
          step: 3,
          car_applicant_id: currentApplicant,
          daily_income: parseInt(incomeData.daily_income ?? "0", 10),
          source_of_income: incomeData.source_of_income ?? "",
          debts: incomeData.hasDebt ?? "",
          car_id: newCarId, 
          car_year: parseInt(incomeData.car_year ?? "0", 10),
          loan_amount: parseInt(incomeData.loan_amount ?? "0", 10),
          repayment_period: parseInt(incomeData.repayment_period ?? "0", 10),
          loan_payment_process: incomeData.loan_payment_process ?? "",

           deposit_accepted: incomeData.deposit_accepted ?? "",
        };

        // console.log("Step 3 Payload (custom car):", payload);
        const response = await fetch(`${motariStaggingUrl}/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const responseData = await response.json();
        console.log("Step 3 response:", responseData);

        if (response.ok) {
          api.success({
            message: "Igikorwa Cyagenze Neza",
            description:
              "Igikorwa cyagenze neza! Komeza ku cyiciro gikurikiraho.",
            placement: "topRight",
            duration: 5,
          });
          const carApplicantId = responseData.car_applicant_id;
          if (carApplicantId) setCurrentApplicant(carApplicantId);
          nextStep();
        } else {
          const errorMessage =
            responseData?.message || "Habayeho ikosa. Ongera ugerageze.";
          api.error({
            message: "Ikosa Ryabaye",
            description: errorMessage,
            placement: "topRight",
            duration: 10,
          });
          if (responseData?.errors) {
            Object.entries(responseData.errors).forEach(([, value]) => {
              api.error({
                message: "Ikosa Ryabaye",
                description: value,
                placement: "topRight",
                duration: 10,
              });
            });
          }
        }

        setIsSubmitting(false);
        return;
      } catch (error) {
        setIsSubmitting(false);
        api.error({
          message: "Ikosa Ryabaye",
          description: error.message || "Habayeho ikosa mu gukora imodoka.",
          placement: "topRight",
        });
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const payload = getStepPayload();
      // console.log("Step Payload:", payload);

      const response = await fetch(`${motariStaggingUrl}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();
      // console.log("car applicant data", responseData);

      if (response.ok) {
        if (currentStep === 9) {
          api.success({
            message: "Igikorwa Cyagenze Neza",
            description: "Igikorwa cyagenze neza! Murakoze",
            placement: "topRight",
            duration: 5,
          });
          setIsConfirmedSent(true);
        } else {
          api.success({
            message: "Igikorwa Cyagenze Neza",
            description:
              "Igikorwa cyagenze neza! Komeza ku cyiciro gikurikiraho.",
            placement: "topRight",
            duration: 5,
          });

          nextStep();

          const carApplicantId = responseData.car_applicant_id;
          // console.log("car applicant carApplicantId", carApplicantId);
          setCurrentApplicant(carApplicantId);
        }
        setIsSubmitting(false);
        return true;
      } else {
        // nextStep();
        if (currentStep === 9) {
          let errorMessage =
            typeof responseData.errors?.message === "string"
              ? responseData.errors.message
              : typeof responseData.message === "string"
                ? responseData.message
                : "Habayeho ikosa. Ongera ugerageze.";

          api.error({
            message: "Ikosa Ryabaye",
            description: errorMessage,
            placement: "topRight",
            duration: 10,
          });

          if (responseData.errors?.incomplete_steps?.length > 0) {
            const incompleteStep = responseData.errors.incomplete_steps[0];
            setTimeout(() => setCurrentStep(incompleteStep + 1), 2000);
          }
        } else {
          if (responseData?.message) {
            api.error({
              message: "Ikosa Ryabaye",
              description: responseData.message,
              placement: "topRight",
              duration: 10,
            });
          }
          if (responseData?.errors) {
            Object.entries(responseData.errors).forEach(([key, value]) => {
              api.error({
                message: "Ikosa Ryabaye",
                description: value,
                placement: "topRight",
                duration: 10,
              });
            });
          }
          setIsSubmitting(false);
          return false;
        }
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      api.error({
        message: "Ikosa Ryabaye",
        description: "Amakuru watanze si yo. Nyamuneka wongere ugenzure",
        placement: "topRight",
      });
      return false;
    }
  };

  // ── Navigation ─────────────────────────────────────────────────────────────
  const nextStep = () => {
    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED" || riderBasicInformation.maritalStatus === "NARASHATS";

    if (currentStep === 3 && isMarried) {
      setCurrentStep(4); // married → wife info
    } else if (currentStep === 3 && !isMarried) {
      setCurrentStep(5); // not married → parent info
    } else if (currentStep === 4 && isMarried) {
      setCurrentStep(6); // married, skip parent info
    } else if (currentStep === 4 && !isMarried) {
      setCurrentStep(5);
    } else if (currentStep === 6) {
      setCurrentStep(
        hasExtraFields && Object.keys(selectedCategory.extra).length > 0
          ? 7
          : 8,
      );
    } else if (currentStep === 7 && !hasExtraFields) {
      setCurrentStep(8);
    } else {
      setCurrentStep((prev) => Math.min(prev + 1, TOTAL_STEPS));
    }
  };

  const previousStep = () => {
    if (isSubmitting) return;

    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED"|| "NARASHATS";

    if (currentStep === 8 && !hasExtraFields) {
      setCurrentStep(6);
    } else if (currentStep === 6 && isMarried) {
      setCurrentStep(4);
    } else if (currentStep === 5 && !isMarried) {
      setCurrentStep(3);
    } else {
      setCurrentStep((prev) => Math.max(prev - 1, 1));
    }
  };

  // ── Persist to localStorage ────────────────────────────────────────────────
  useEffect(() => {
    localStorage.setItem(
      "riderBasicInformation",
      JSON.stringify(riderBasicInformation),
    );
    localStorage.setItem(
      "riderIdentification",
      JSON.stringify(riderIdentification),
    );
    localStorage.setItem("incomeData", JSON.stringify(incomeData));
    localStorage.setItem(
      "wifeIdentifications",
      JSON.stringify(wifeIdentifications),
    );
    localStorage.setItem(
      "parentInformation",
      JSON.stringify(parentInformation),
    );
    localStorage.setItem("guarantor", JSON.stringify(guarantor));
    localStorage.setItem("customStep", JSON.stringify(customStep));
  }, [
    riderBasicInformation,
    riderIdentification,
    incomeData,
    wifeIdentifications,
    parentInformation,
    guarantor,
    customStep,
  ]);

  // ── Auto-skip steps based on marital status ────────────────────────────────
  useEffect(() => {
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED"|| "NARASHATS";
    if (currentStep === 4 && !isMarried) setCurrentStep(5);
    if (currentStep === 5 && isMarried) setCurrentStep(6);
  }, [currentStep, riderBasicInformation.maritalStatus]);

  useEffect(() => {
    dispatch(fetchAsyncProvinces());
  }, [dispatch]);

  // ── Progress ───────────────────────────────────────────────────────────────
  const calculateProgress = () => {
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED"|| "NARASHATS";
    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;

    let totalSteps = TOTAL_STEPS;
    if (isMarried) totalSteps -= 1; // skip parent info
    if (!isMarried) totalSteps -= 1; // skip wife info
    if (!hasExtraFields) totalSteps -= 1; // skip custom step

    let adjustedStep = currentStep;
    if (isMarried && currentStep > 4) adjustedStep -= 1;
    if (!hasExtraFields && currentStep > 6) adjustedStep -= 1;

    return Math.round((adjustedStep / totalSteps) * 100);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div
      className={`min-h-screen flex flex-col items-center transition-colors duration-300 w-full ${
        darkMode
          ? "bg-gradient-to-br from-[#151f3b] via-[#20409A] to-[#192853] text-white"
          : "bg-[#20409A] text-white"
      }`}
    >
      {contextHolder}

      <h2
        className={`text-lg sm:text-xl md:text-2xl lg:text-2xl font-bold py-4 text-center ${
          darkMode ? "text-white" : "bg-[#20409A] text-white"
        }`}
      >
        <span className="inline-block text-lg">
          UZUZA UMWIRONDORO W'UMUSHOFERI USHAKA INGUZANYO Y'IMODOKA
        </span>
      </h2>

      {!isConfirmedSent && (
        <div className="w-full max-w-xl p-6 bg-gradient-to-br from-gray-900/50 to-gray-900/50 rounded-2xl shadow-lg">
          {/* Progress bar */}
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium">
              Icyiciro {currentStep} cya {TOTAL_STEPS}
            </span>
            <span className="text-sm font-medium">{calculateProgress()}%</span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2 mb-3">
            <div
              className="bg-blue-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${calculateProgress()}%` }}
            />
          </div>

          <div className="flex justify-between items-center mb-4">
            <h1 className="text-lg font-semibold uppercase">
              {STEP_TITLES[currentStep]}
            </h1>
          </div>

          {/* Loading overlay */}
          {isSubmitting && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center">
                <Spin indicator={antIcon} size="large" />
                <p className="mt-4 text-gray-700 font-medium">
                  {currentStep === 8
                    ? "Ohereza dosiye..."
                    : "Ohereza amakuru..."}
                </p>
                {currentStep === 8 && uploadProgress > 0 && (
                  <div className="mt-4">
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${uploadProgress}%` }}
                      />
                    </div>
                    <p className="mt-2 text-sm text-gray-600">
                      {uploadProgress}%
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}

          <AnimatePresence mode="wait">
            {currentStep === 1 && (
              <motion.div
                key="step1"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <RiderIdenfification
                  data={riderIdentification}
                  onChangeHandleRinderInfo={handleRiderIdentificationChange}
                />
              </motion.div>
            )}

            {currentStep === 2 && (
              <motion.div
                key="step2"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <BasicInformation
                  data={riderBasicInformation}
                  basicInformation={handleBasicInformationChange}
                />
              </motion.div>
            )}

            {currentStep === 3 && (
              <motion.div
                key="step3"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <YourIncome
                  data={incomeData}
                  transmission={incomeData?.preferredMotoType?.id}
                  HandleIncomeData={HandleIncomeData}
                />
              </motion.div>
            )}

            {currentStep === 4 &&
              riderBasicInformation.maritalStatus === "MARRIED"|| "NARASHATS" && (
                <motion.div
                  key="step4"
                  variants={stepVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  <WifeIndentification
                    data={wifeIdentifications}
                    onChangeWifeIdentifications={handleWifeIdentificationChange}
                  />
                </motion.div>
              )}

            {currentStep === 5 && (
              <motion.div
                key="step5"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ParentInformation
                  data={parentInformation}
                  onChangeParentInfo={handleParentInformationChange}
                />
              </motion.div>
            )}

            {currentStep === 6 && (
              <motion.div
                key="step6"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <Guarantor
                  data={guarantor}
                  bikeType={incomeData?.preferredMotoType?.transmission}
                  onChange={handleGuarantorChange}
                />
              </motion.div>
            )}

            {currentStep === 7 && (
              <motion.div
                key="step7"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <CustomStep
                  data={customStep}
                  preferredMotoType={incomeData?.preferredMotoType}
                  onChangeCustomStep={handleCustomStepChange}
                />
              </motion.div>
            )}

            {currentStep === 8 && (
              <motion.div
                key="step8"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <UploadedCopy
                  data={uploadedCopies}
                  onChange={handleUploadedCopiesChange}
                />
              </motion.div>
            )}

            {currentStep === 9 && (
              <motion.div
                key="step9"
                variants={stepVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ConfirmSection
                  isConfirmed={isConfirmed}
                  onConfirmChange={handleConfirmChange}
                />
              </motion.div>
            )}
          </AnimatePresence>

          {/* Navigation buttons */}
          <div className="flex justify-between mt-6">
            <div>
              {currentStep > 1 && (
                <Button
                  type="default"
                  onClick={previousStep}
                  disabled={currentStep === 1 || isSubmitting}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg flex items-center hover:bg-gray-300"
                >
                  Ahabanza
                </Button>
              )}
            </div>
            <div className="flex space-x-4">
              {currentStep < 9 && (
                <Button
                  type="primary"
                  onClick={submitStepData}
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-blue-900 text-white rounded-lg flex items-center hover:bg-blue-800"
                >
                  {isSubmitting ? "Ohereza..." : "Komeza"}
                </Button>
              )}

              {currentStep === 9 && (
                <Button
                  type="primary"
                  disabled={!isConfirmed || isSubmitting}
                  onClick={submitStepData}
                  loading={isSubmitting}
                  className="px-4 py-2 bg-blue-900 text-white rounded-lg flex items-center hover:bg-blue-800"
                >
                  {isSubmitting ? "Ohereza..." : "Iyandikishe"}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {isConfirmedSent && (
        <div className="w-full max-w-xl p-6 bg-gradient-to-br from-gray-900/50 to-gray-900/50 rounded-2xl shadow-lg">
          <SuccessMessage />
          <Button
            className="text-white mx-6 mt-4 bg-blue-900 hover:bg-blue-800"
            onClick={resetApplicationForm}
          >
            Reset form
          </Button>
        </div>
      )}
    </div>
  );
};

export default CarMultiStepForm;
